import { useState } from "react";
import homeStyles from "../HomeLayout.module.scss";
import styles from "./GuidelinesSection.module.scss";
import GuidelinesGrid from "../../shared/GuidelinesGrid";
import { GUIDELINES_MENU_ITEMS } from "../../../constants/navigation";
import useScreenSize from "../../../hooks/useScreenSize";

const GuidelinesSection = () => {
  const [showAll, setShowAll] = useState(false);
  const { isTabletSize } = useScreenSize();

  // Show 10 guidelines on tablet, 9 on other devices
  const initialLimit = isTabletSize ? 10 : 9;

  const handleToggleView = () => {
    setShowAll(!showAll);
  };

  return (
    <section className={homeStyles.section}>
      <h2 className={homeStyles.title}>Guidelines</h2>
      <div className={styles.guidelinesContainer}>
        <div className={styles.gridWrapper}>
          <GuidelinesGrid
            variant="landing"
            className={styles.guidelinesGrid}
            limitItems={showAll ? null : initialLimit}
          />
        </div>

        {GUIDELINES_MENU_ITEMS.length > initialLimit && (
          <div className={styles.viewToggleContainer}>
            <button
              className={styles.viewToggleButton}
              onClick={handleToggleView}
              aria-expanded={showAll}
              aria-label={showAll ? "View less guidelines" : "View all guidelines"}
            >
              {showAll ? "View less" : "View all"}
              <i className={showAll ? "tg-icons-ChevronUp" : "tg-icons-ChevronDown"}></i>
            </button>
          </div>
        )}
      </div>
    </section>
  );
};

export default GuidelinesSection;
